var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpaceLocationGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 67,
    viewBox: "0 0 55 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9452 50.0619C52.1027 44.5614 55 37.1028 55 29.3258C55 21.5489 52.1027 14.0903 46.9452 8.58978C44.3923 5.86661 41.3609 3.70636 38.0244 2.23249C34.6879 0.758611 31.1117 0 27.5 0C23.8883 0 20.3121 0.758611 16.9756 2.23249C13.6391 3.70636 10.6077 5.86661 8.05478 8.58978C2.89725 14.0903 0 21.5489 0 29.3258C0 37.1028 2.89725 44.5614 8.05478 50.0619L14.0298 56.3388L22.0553 64.6508L22.5778 65.145C25.6223 67.7747 30.0809 67.6072 32.9486 64.6508L42.5141 54.7267L46.9452 50.0619V50.0619ZM27.5 41.8755C24.3744 41.8755 21.3769 40.552 19.1668 38.1961C16.9566 35.8402 15.715 32.645 15.715 29.3133C15.715 25.9816 16.9566 22.7863 19.1668 20.4304C21.3769 18.0746 24.3744 16.751 27.5 16.751C30.6256 16.751 33.6231 18.0746 35.8332 20.4304C38.0434 22.7863 39.285 25.9816 39.285 29.3133C39.285 32.645 38.0434 35.8402 35.8332 38.1961C33.6231 40.552 30.6256 41.8755 27.5 41.8755Z",
    fill: "#A6E327"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpaceLocationGreen);
export default __webpack_public_path__ + "static/media/icon-spaceLocationGreen.da76a8ea08cd2e2257109452c2346218.svg";
export { ForwardRef as ReactComponent };